import imageSizes from 'utils/imageSizes.json';

export const getHeightByWidthAndAspectRatio = (newWidth, proportion, size) => {
  const foundImageSize = imageSizes.find(img => img.proportion === proportion && img.size === size);
  if (!foundImageSize) {
    throw new Error('Could not find an image with that proportion or size');
  }
  return Math.round((newWidth * foundImageSize.height) / foundImageSize.width);
};
